/* HYP infinite scroll for collection pages — prefetch edition.
   - The NEXT page is fetched in the background as soon as the current one
     renders, so appending is instant when the user approaches the bottom.
   - If the user outruns loading (slams to the very bottom), pages chain-load
     back-to-back until the sentinel is out of range.
   - Survives facet filtering re-renders via MutationObserver re-init. */
(function () {
  'use strict';

  var SECTION_SEL = '.shopify-section--main-collection';
  var LOOKAHEAD_PX = 2400; // how far below the viewport counts as "near"
  var appending = false;

  function getSection() {
    return document.querySelector(SECTION_SEL);
  }

  function setup(section) {
    var list = section.querySelector('product-list');
    var nextLink = section.querySelector('nav.pagination a[rel="next"]');
    if (!list || !nextLink) return;
    if (section.querySelector('.hyp-inf-sentinel')) return; // already active

    var pagination = nextLink.closest('nav.pagination');
    if (pagination) pagination.style.display = 'none';

    var sentinel = document.createElement('div');
    sentinel.className = 'hyp-inf-sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'height:1px;width:100%;';
    list.parentNode.insertBefore(sentinel, list.nextSibling);

    var nextUrl = nextLink.href;
    var prefetchPromise = null;
    var busy = false;
    var done = false;

    function fetchPage(url) {
      return fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newSection = doc.querySelector(SECTION_SEL);
          var newList = newSection && newSection.querySelector('product-list');
          var newNext = newSection && newSection.querySelector('nav.pagination a[rel="next"]');
          var nodes = [];
          if (newList) {
            while (newList.firstChild) {
              nodes.push(newList.firstChild);
              newList.removeChild(newList.firstChild);
            }
          }
          return { nodes: nodes, next: newNext ? newNext.href : null };
        });
    }

    function startPrefetch() {
      if (!prefetchPromise && nextUrl && !done) {
        prefetchPromise = fetchPage(nextUrl);
      }
    }

    function appendResult(res) {
      appending = true;
      var frag = document.createDocumentFragment();
      for (var i = 0; i < res.nodes.length; i++) frag.appendChild(res.nodes[i]);
      list.appendChild(frag);
      setTimeout(function () { appending = false; }, 0);

      nextUrl = res.next;
      if (!nextUrl) {
        done = true;
        io.disconnect();
        sentinel.remove();
      }
    }

    function sentinelNear() {
      if (done || !sentinel.isConnected) return false;
      var rect = sentinel.getBoundingClientRect();
      return rect.top < window.innerHeight + LOOKAHEAD_PX;
    }

    function pump() {
      if (busy || done) return;
      if (!prefetchPromise) {
        if (!nextUrl) { done = true; return; }
        startPrefetch();
      }
      busy = true;
      prefetchPromise
        .then(function (res) {
          prefetchPromise = null;
          busy = false;
          appendResult(res);
          if (!done) {
            startPrefetch();          // warm the following page immediately
            if (sentinelNear()) pump(); // user is outrunning us: chain-load
          }
        })
        .catch(function () {
          busy = false;
          prefetchPromise = null;
        });
    }

    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) pump();
    }, { rootMargin: LOOKAHEAD_PX + 'px 0px' });

    io.observe(sentinel);

    // Warm page 2 right away — by the time anyone scrolls, it's ready.
    startPrefetch();
  }

  function scan() {
    if (appending) return;
    var section = getSection();
    if (section) setup(section);
  }

  function init() {
    var section = getSection();
    if (!section) return;
    setup(section);

    // The facet filters re-render the section content in place; re-attach
    // whenever the grid is replaced.
    var mo = new MutationObserver(function () {
      if (appending) return;
      window.clearTimeout(init._t);
      init._t = window.setTimeout(scan, 150);
    });
    mo.observe(section, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
